/*
 * File: useResendVerificationEmail.ts
 * Author: Austin Robinson
 * Date Created: 8/31/2025
 * Copyright (c) DrivingDoc 2025
 */
import { createMutation } from 'react-query-kit';

import { ErrorResponse, publicApi } from 'api';

export interface ResendVerificationEmailParams {
  /**
   * Email verification token
   *
   * @type {string}
   */
  email: string;
}

export interface ResendVerificationEmailResult {
  success: boolean;
}

async function resendVerificationEmail({ email }: ResendVerificationEmailParams): Promise<boolean> {
  // make api call
  const result = await publicApi.post<ResendVerificationEmailResult>(`/public/auth/email/resend`, {
    email,
  });

  // return the data object
  return result.data.success;
}

const useResendVerificationEmail = createMutation<boolean, ResendVerificationEmailParams, ErrorResponse>({
  mutationFn: resendVerificationEmail,
});

export { useResendVerificationEmail };
